import React from 'react'
import {   Field} from 'redux-form'

export class SVVCOInputEp extends React.Component{

    constructor(props){
        super(props)
    }
  
    componentWillReceiveProps(next){
        console.log('props changed SVString')
    }
   
    render(){
        
       
          /*svj21 start*/
          console.log('***svj21****  SVICO countryTwoTypes')
          const {countryTwoTypes} = this.props
          console.log("*******svj2****ADoc countryTwoTypes** START")
          console.log(countryTwoTypes)

          console.log("*******svj21****ADevice** END")

            /*svj21 end*/
        let me = this
       let {member,index, placeholder ='Port Z'} = this.props
        
            

          return (
            
   

                <Field  
                component="select" 
                id={`${member}.validityCountry`}
                name={`${member}.validityCountry`}
                className="form-control" >
                                                
                                                <option value="">Select Validating  Country /A2 Code</option>
                                                    {
                                        
                                                
                                        countryTwoTypes.map(  (o, idx)=>(  <option value={o.value} key={o.name}>{o.name}</option>)
                                                    
                                                    
                                                    
                                                
                                                )}
    
                     </Field>    
                                  
          
           )
    }
}